// MIRRORED FILE — twin of src/utils/clientInvoiceTtd.js (line-for-line).
// CRA's ModuleScopePlugin forbids importing the repo's src/, so the invoice page keeps a copy.
// Registered in `PAIRS` of `mirroredUtilParity.test.js`.
//
// D119.13: the ONE owner of "this invoice amount in TT$". The Margin-by-vessel report and the
// invoice's Profitability tab both call it, so they cannot disagree. Pure; it reads no rate: the
// caller passes the rate PINNED on the invoice (hard invariant 5, never today's).
import { num, round2 } from './invoiceLineMath';

/**
 * @param amount an amount in the invoice's own currency
 * @param currency the invoice currency ('TTD' is taken as is, 'USD' needs a rate)
 * @param usdToTtd TT$ per US$1, pinned on the invoice
 * @returns TT$ to the cent; null when the amount is missing, the currency is not TTD/USD, or a
 *   USD amount has no positive rate. Missing is never 0.
 */
export function ttdAmount(amount: any, currency: any, usdToTtd: any): number | null {
  const n = num(amount);
  if (n === null) return null;
  const code = String(currency ?? '').trim().toUpperCase();
  if (code === 'TTD') return round2(n);
  const rate = num(usdToTtd);
  if (code === 'USD' && rate !== null && rate > 0) return round2(n * rate);
  return null;
}
